// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1gVAB","tab":"Tabs_tab__28Nkj","tabActive":"Tabs_tabActive__2nS4m"};